import {toggleIcon} from "../../ViewModels/elementview.js"
import {filterIcon} from "../../ViewModels/elementview.js"
import {toggleLocationPanel} from "../../ViewModels/locationview.js"

import { ifcTrimmer } from "../IFC/IFCMeshHandler.js";
import { meshClasher } from "../IFC/IFCMeshHandler.js";
import { ifcMeshPlacer } from "../IFC/IFCMeshHandler.js";
import { meshBvhIndexer } from "../IFC/BoundingVolumeHierarchy.js";
import {exportData} from "../../Data/DataManagers/DataConverters/ExportData.js"
import {findElementById} from "../World/CustomHighlighter.js"
import ClashModelManager from "../../Data/DataManagers/ClashModelManager.js";
import {showClashOverviewPanel} from "../../ViewModels/clashoverview.js";
import { setModelParameters } from "../IFC/IFCMeshHandler.js";
//import Experience from "../Experience.js";


/**
 * EventListener for a ButtonClickEvent
 */
export default class ButtonClickListener {
    constructor() {


        //this.experience = new Experience();

        const fileButton = document.getElementById('fileButton');
        const fileInput = document.getElementById('fileInput');

        if (fileButton && fileInput) {
            fileButton.addEventListener('click', () => {
                //console.log("Button clicked")
                fileInput.click();


            });


        } 






        // const togglePanelButton  = document.getElementById('togglePanelButton');

        // if (togglePanelButton) {
        //     togglePanelButton.addEventListener('click', () => {
        //         treeviewPanel.classList.toggle('hidden');
        // })};

        //const treeviewPanel = document.getElementById('treeviewPanel');
        //const locationButton = document.getElementById("locationButton");
        
        
        const bvhButton = document.getElementById("bvhButton");

        // Add the event listener for the toggle button
        const elementtogglebutton = document.getElementById("toggleButton");      
        const elementfilterbutton = document.getElementById("filterButton");      

        // Add the event listener for the clash button
        const clashbutton = document.getElementById("clashButton");  
          

        // Add the event listener for the trim button
        //const trimbutton = document.getElementById("trimButton");      

        // Add the event listener for the trim button
        const pastebutton = document.getElementById("pasteButton");      


        // Add the event listener for the export csv button
        const exportcsvbutton = document.getElementById("exportCSVButton");      
        // Add the event listener for the export json button
        const exportjsonbutton = document.getElementById("exportJsonButton");

        // Add the event listener for the export json button
        const selectByIdbutton = document.getElementById("selectByIDButton");
        const idsearchpanel = document.getElementById("searchPanel");
        const findElementButton = document.getElementById("findElementButton");
        const cancelButton = document.getElementById("cancelButton");



        //console.log("Button Listened")





        if(elementtogglebutton)
        {
            elementtogglebutton.addEventListener("click", toggleIcon);

        }

        if(elementfilterbutton)
        {
            elementfilterbutton.addEventListener("click", filterIcon)
        }

        // if(locationButton)
        // {
        //     locationButton.addEventListener("click", toggleLocationPanel)
        // }

        if(clashbutton)
            {
                clashbutton.addEventListener("click", meshClasher)
            }


        const clashoverviewbutton = document.getElementById("clashOverviewButton");
        if (clashoverviewbutton) {
        
            clashoverviewbutton.addEventListener("click", showClashOverviewPanel)

        }

        const getClashParametersbutton = document.getElementById("getClashParameters");
        if(getClashParametersbutton){
            getClashParametersbutton.addEventListener("click", setModelParameters)
        }


        if(bvhButton)
            {
               
                bvhButton.addEventListener("click", meshBvhIndexer)
            }

        if(pastebutton)
            {
                
                pastebutton.addEventListener("click", ifcMeshPlacer)
            }

        if(exportcsvbutton)
            {
                exportcsvbutton.addEventListener("click", () => exportData("csv"))
                

            }

        if(exportjsonbutton)
        {
            exportjsonbutton.addEventListener("click", () => exportData("json"))
        }

        if(selectByIdbutton)
        {
            // Toggle the panel when clicking the "Select by ID" button
            selectByIdbutton.addEventListener("click", () => {
                idsearchpanel.classList.toggle("hiddenSearchPanel"); // Toggle visibility
                document.getElementById("elementIdInput").focus(); // Focus input field
            });

            // Find Element event (added only once)
            findElementButton.addEventListener("click", () => {
                findElementById();  // Call function to find the element
                console.log("find");
                idsearchpanel.classList.add("hiddenSearchPanel"); // Hide panel
            });

            // Cancel Button event (added only once)
            cancelButton.addEventListener("click", () => {
                console.log("cancel");
                idsearchpanel.classList.add("hiddenSearchPanel"); // Hide panel
            });
        }




    }
}
